import { render, staticRenderFns } from "./addHpgp.vue?vue&type=template&id=2c2ad3d6"
import script from "./addHpgp.vue?vue&type=script&lang=js"
export * from "./addHpgp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports